import { Avatar } from '@eventbrite/marmalade';
import styles from './HostImage.module.scss';
import { Host } from './Host';
import { getImageProps } from 'next/image';

interface Props {
  host: Host;
  style?: React.CSSProperties;
}

export const HostImage: React.FC<Props> = ({ host, style }) => {
  const {
    props: { src },
  } = getImageProps({
    alt: '',
    width: 25,
    height: 25,
    src: host.image?.url || '',
  });

  return <Avatar size="small" placeholder={host.name} imageSrc={src} className={styles.avatar} style={style} />;
};
